import React from 'react';
import { ScenarioInsightId, SupplyShedDriveTime } from '../../lib/types';
import { PrivateTimberlandCarbonMaintenanceCard } from './insights/PrivateTimberlandCarbonMaintenanceCard';
import { ResiliencePriorityMatrixCard } from './insights/ResiliencePriorityMatrixCard';
import { PerTreeCarbonRollupCard } from './insights/PerTreeCarbonRollupCard';

interface ScenarioInsightCardProps {
  insightId: ScenarioInsightId;
  millCode: string | null;
  driveTime: SupplyShedDriveTime;
}

// Dispatcher — chooses the right insight card for the scenario's final step.
// Each card is self-contained: it owns its data hook, loading state, and
// empty-state rendering.
export const ScenarioInsightCard: React.FC<ScenarioInsightCardProps> = ({
  insightId,
  millCode,
  driveTime,
}) => {
  switch (insightId) {
    case 'private_timberland_carbon_maintenance':
      return <PrivateTimberlandCarbonMaintenanceCard millCode={millCode} driveTime={driveTime} />;
    case 'resilience_priority_matrix':
      return <ResiliencePriorityMatrixCard millCode={millCode} driveTime={driveTime} />;
    case 'per_tree_carbon_rollup':
      return <PerTreeCarbonRollupCard millCode={millCode} driveTime={driveTime} />;
    default:
      // Compile-time exhaustiveness guard. Adding a new ScenarioInsightId
      // without a matching case above fails the build because the
      // assignment-to-never below requires the union to be already
      // narrowed away. At runtime — when the type system is bypassed (e.g.
      // a hand-rolled string cast on a malformed scenario) — return null
      // cleanly so the panel just hides the insight slot.
      return assertNever(insightId);
  }
};

const assertNever = (_: never): null => null;
